import { type ErrorCorrectionContextType, ErrorCorrectionContext } from 'error-correction'
import { useContext } from 'react'

export const useErrorCorrectionContext = (): ErrorCorrectionContextType => {
  const context = useContext(ErrorCorrectionContext)

  if (context === null) {
    throw new Error('useErrorCorrectionContext must be used within an ErrorCorrectionProvider')
  }

  return context
}
